import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { UserStammdaten } from './stammdaten.js';
import { User } from './user.js';

@Entity()
export class RegistrationProductData extends AdornisEntity {
  static override _class = 'RegistrationProductData';

  @validate(nonOptional())
  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @validate(nonOptional())
  @Field(type => String)
  productID!: string;
}

@Entity()
export class RegistrationWorkshopData extends RegistrationProductData {
  static override _class = 'RegistrationWorkshopData';
}

@Entity()
export class RegistrationEinzelberatungData extends RegistrationProductData {
  static override _class = 'RegistrationEinzelberatungData';

  @validate(nonOptional())
  @Field(type => String)
  timeslotID!: string;
}

@Entity()
export class BookingResult extends AdornisEntity {
  static override _class = 'BookingResult';

  @Field(type => String)
  loginToken!: string;

  @Field(type => [String])
  participationIDs!: string[];

  @Field(type => Boolean)
  paymentRequired!: boolean;

  @Field(type => [String])
  paymentIDs?: string[];
}

@Entity()
export class RegistrationData extends AdornisEntity {
  static override _class = 'RegistrationData';

  @validate(nonOptional())
  @Field(type => String)
  institutionID!: string;

  @validate(nonOptional())
  @Field(type => [RegistrationProductData], { default: v => v ?? [] })
  productData!: RegistrationProductData[];

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => Boolean, { default: v => v ?? false })
  acceptedTerms!: boolean;

  @Field(type => UserStammdaten)
  userStammdaten: Maybe<UserStammdaten>;

  @Field(type => User)
  user: Maybe<User>;
}
